import { PubSub } from './pub-sub';
var Cycle = /** @class */ (function () {
    function Cycle() {
        this._cycles = {};
    }
    Cycle.prototype.add = function (form, type, callback) {
        var _a;
        /**
         * 使用 uuid 保证 FormArray children 在切换顺序 address 被修改后，依然能通知到正确的 node
         */
        if (!this._cycles[form.uuid]) {
            this._cycles[form.uuid] = {};
        }
        if (!this._cycles[form.uuid][type]) {
            this._cycles[form.uuid][type] = new PubSub();
        }
        return ((_a = this._cycles[form.uuid][type]) === null || _a === void 0 ? void 0 : _a.subscribe(callback)) || (function () { });
    };
    Cycle.prototype.publish = function (form, type, payload) {
        var _a, _b;
        if ((_a = this._cycles[form.uuid]) === null || _a === void 0 ? void 0 : _a[type]) {
            (_b = this._cycles[form.uuid][type]) === null || _b === void 0 ? void 0 : _b.notify(payload);
        }
    };
    return Cycle;
}());
export { Cycle };
